export default {
  uid: '',
  nid: '',
  batch_id: '',
  appTitle: null // 自制标题栏的title
}



//////////////////
// WEBPACK FOOTER
// ./static/global.js
// module id = null
// module chunks = 